import Transition from "./Transition";
import {Power3, Back, Circ} from "gsap";

class VoidCenterTransition extends Transition {

    constructor( _elem, autoplay = false ) {
        super( _elem, autoplay )
    }

    animateMasks() {
        this.tl.from( '.shape-bg svg', 1.5, { scale: 1.5, ease: Circ.easeOut }, 0 );

        this.tl.to(this.elem.querySelector('.mask-inner'), this.maskSpeed, {
            top: '-100%',
            ease: Power3.easeOut
        }, 0);
    }

}

export default VoidCenterTransition;